var exports = {
  "n": "x9245d464--2be11b--link",
};

module.exports = exports;
